import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    _classCallCheck(this, Subscribable);
    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }
  _createClass(Subscribable, [{
    key: "subscribe",
    value: function subscribe(listener) {
      var _this = this;
      var identity = {
        listener: listener
      };
      this.listeners.add(identity);
      this.onSubscribe();
      return function () {
        _this.listeners.delete(identity);
        _this.onUnsubscribe();
      };
    }
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return this.listeners.size > 0;
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {// Do nothing
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {// Do nothing
    }
  }]);
  return Subscribable;
}();
export { Subscribable };